import { SingleEntityState, StoreState } from 'src/types';
import BookingProgress from 'src/entities/booking/progress/BookingProgress';

export const getBookingProgress = (state: StoreState): SingleEntityState<BookingProgress> => state.booking;
